<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="automationList"
          description
          search
          @selected="openView"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.automation_master") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                @click="$router.push({ name: 'Create Automation' })"
                size="small"
                >{{ $t("setup.label.create_automation") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.AutomationId") }}</vs-th>
            <vs-th>{{ $t("setup.label.EntityName") }}</vs-th>
            <vs-th>{{ $t("setup.label.EntityType") }}</vs-th>
            <vs-th>{{ $t("setup.label.WorkflowName") }}</vs-th>
            <vs-th>{{ $t("setup.label.SubCategory") }}</vs-th>
            <vs-th>{{ $t("setup.label.CityName") }}</vs-th>
            <vs-th>{{ $t("setup.label.Priority") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="data" v-for="(obj, index) in data">
              <vs-td :data="obj.id">{{ obj.id }}</vs-td>
              <vs-td :data="obj.entityName">{{ obj.entityName }}</vs-td>
              <vs-td :data="obj.entityType">{{ obj.entityType }}</vs-td>
              <vs-td :data="obj.workflowName">{{ obj.workflowName }}</vs-td>
              <vs-td :data="obj.subcategory">{{ obj.subcategory }}</vs-td>
              <vs-td :data="obj.cityName">{{ obj.cityName }}</vs-td>
              <vs-td :data="obj.priority">{{ obj.priority }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('setup.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editData(obj.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = obj.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <delete-popup
        :deletePopup="deleteItemPopup"
        :title="$t('setup.label.automation')"
        @deletePressed="removeCollection(delId)"
        @cancelPressed="deleteItemPopup = false"
      >
      </delete-popup>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      automationList: (state) => state.automationMaster.automationList,
    }),
  },
  methods: {
    async getAutomationMasterMethod() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "automationMaster/getAutomationMasterListAction"
        );
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
      this.loading = false;
    },
    editData(id) {
      this.$router.push({
        name: "Edit Automation",
        params: { id: id },
      });
    },
    openView(d) {
      const data = d[0];
      this.$router.push({
        name: "Automation Detail",
        params: { id: data.id },
      });
    },
    async removeCollection(id) {
      try {
        await this.$store.dispatch(
          "automationMaster/deleteAutomationMasterAction",
          id
        );
        this.deleteItemPopup = false;
        await this.$toasted.success("Deleted Successfully", {
          duration: 2000,
        });
        await this.getAutomationMasterMethod();
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
  },
  mounted() {
    this.getAutomationMasterMethod();
  },
};
</script>

<style lang="scss"></style>
